// extracted by mini-css-extract-plugin
module.exports = {"EstimateHeader":"Page_EstimateHeader__RSyv1","EstimateTitle":"Page_EstimateTitle__AXglK"};